export default __webpack_public_path__ + "static/media/ISKO CLASS-4 EXAM PATTERN 2026-27.f770d2f6.pdf";